import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=3e1e1148&scoped=true&"
import script from "./IconComponent.vue?vue&type=script&lang=js&"
export * from "./IconComponent.vue?vue&type=script&lang=js&"
import style0 from "./IconComponent.vue?vue&type=style&index=0&id=3e1e1148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e1148",
  null
  
)

export default component.exports